<template>
    <div class="hello">
        <img class="img" src="static/banner.jpg" alt="">
    </div>
</template>

<script>
export default {
    name: "HelloWorld",
    data() {
        return {
            msg: "Welcome to Your Vue.js App",
        };
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hello {
    height: 100%;
}
.img {
    width: 100%;
    height: 100%;
    display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue